import React, { useRef, useEffect, useState } from "react";
import PhotoCameraWhite from "../assets/PhotoCameraWhite.png";
import PhotoCameraBlack from "../assets/PhotoCameraBlack.png";
import "./webCam.css";
import axios from "axios";
import { toast } from "react-toastify";
import { FOLDERPATH } from "../../../Constants/config";
import { handleApiError } from "../../../Helper/actionHelper";
import { useNavigate } from "react-router-dom";
import { getNIDDetailsWithOCR } from "../../../Actions/nidAction";
import { useDispatch } from "react-redux";

const WebCam = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const videoRef = useRef(null);
  const photoRef = useRef(null);

  const [hasPhoto, setHasPhoto] = useState(false);
  const [photoBase64, setPhotoBase64] = useState();
  const [reference, setReference] = useState();

  const getVideo = async () => {
    try {
      var video = document.createElement('video');
      console.log("video reference..", video)
      video.style.width = document.width + 'px';
      video.style.height = document.height + 'px';
      video.setAttribute('autoplay', '');
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: false,
        video: {
          facingMode: "user"
        }
      });
      videoRef.current.srcObject = stream;
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {

    let ref = '';
      let list = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      ref = list.reference_number;
    // }
    setReference(ref);
    
  }, []);

  const takePhoto = () => {
    const width = 414;
    const height = 324;
    const video = videoRef.current;
    const photo = photoRef.current;

    photo.width = width;
    photo.height = height;

    const ctx = photo.getContext("2d");
    ctx.drawImage(video, 0, 0, width, height);
    const currentPhoto = photoRef.current.toDataURL();
    setPhotoBase64(currentPhoto);
    // console.log("image", currentPhoto);
    setHasPhoto(true);
  };

  const closePhoto = () => {
    const photo = photoRef.current;
    const ctx = photo.getContext("2d");
    ctx.clearRect(0, 0, photo.width, photo.height);
    setHasPhoto(false);
  };
  const uploadPhoto = async() => {
    // debugger
    // saveSelfie();
    // const photo = photoRef.current;
    // const ctx = photo.getContext("2d");
    // ctx.clearRect(0, 0, photo.width, photo.height);
    console.log("photo", photoBase64);
    
      try {
        let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
        let payload = {
          "token": userLocalData.id,
          "selfie": photoBase64
        }
  
        const headers = {
          "Content-Type": "application/json",
          Username: "ibridge",
          Password: "ibridge@2020",
        };
  
        const { data } = await axios.post(FOLDERPATH + 
          "/InstantNid/uploadSelfie",
          payload,
          {
            headers,
          }
        );
        
        if (data.status == "success") {
          const msg = "File uploaded successfully";
  
          toast.success(msg, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
  
        handleApiError(data);
      } catch (error) {
        toast.error("Something went wrong. Please try again.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
       
        handleApiError(error);
      }
      debugger
      // console.log(setShowSelfieUpload);
      // setHasPhoto(false);
      // setShowSelfieUpload(false);
      // navigate(`/case-initiation/check-detail/${reference}/nid`)
       dispatch(getNIDDetailsWithOCR());
        window.location.reload();
      // handleSelfieUpload()
    
  };

  useEffect(() => {
    getVideo();
  }, []);

  return (
    <div>
      {<div className="camera m-0 p-0 h-100 w-100 d-flex flex-column align-items-start justify-content-center position-relative">
        <video ref={videoRef} autoPlay={true} muted playsInline={true}></video>
        <div className="oval"></div>
        <p className="d-flex align-items-center justify-content-center py-2 w-100">
          Keep your face within the oval.
        </p>
        <div className="d-flex align-items-center justify-content-center py-2 w-100">
          <button
            type="button"
            className="btn btn-primary text-white d-flex align-items-center justify-content-center px-5 rounded"
            onClick={takePhoto}
          >
            <span className="pr-2">
              <img
                src={PhotoCameraWhite}
                alt="PhotoCameraWhite"
                style={{ maxWidth: "15px", paddingBottom: "3px" }}
              />
            </span>
            Take selfie
          </button>
        </div>
      </div>}
      <div
        className={`result d-flex flex-column align-items-center justify-content-center m-0 p-0 h-100 w-100 ${
          hasPhoto ? "hasPhoto" : ""
        }`}
      >
        <canvas
          ref={photoRef}
          style={{
            maxWidth: "100%",
            maxHeight: "100%",
          }}
        ></canvas>
        <div className="d-flex align-items-center justify-content-center pt-2 mt-5">
          <button
            type="button"
            className="btn btn-outline-secondary d-flex align-items-center justify-content-center h-100 mr-2 ml-5 px-5"
            style={{
              borderRadius: "9px",
            }}
            onClick={closePhoto}
          >
            <span className="pr-2">
              <img
                src={PhotoCameraBlack}
                alt="PhotoCameraBlack"
                style={{ maxWidth: "15px", paddingBottom: "3px" }}
              />
            </span>
            Retake
          </button>
          <button
            type="button"
            className="btn btn-primary text-white d-flex align-items-center justify-content-center h-100 mr-5 ml-2 px-5"
            style={{
              borderRadius: "9px",
            }}
            onClick={uploadPhoto}
          >
            Upload selfie
          </button>
        </div>
      </div>
    </div>
  );
};

export default WebCam;
